import type { NewsPost } from "./types";

// ══════════════════════════════════════════════════════════════════════════════
//   NEWS ARTICLES
//   Add a post by copying articleTemplate (below the list) into the list, changing every
//   field and setting status: "published". Newest posts are listed first, whatever their
//   order here. Until one is live, the news areas show a "Coming soon" card.
//   Full instructions: src/content/README.md
// ══════════════════════════════════════════════════════════════════════════════

export const newsPosts: NewsPost[] = [
  // Articles go here
];

// ── Template: shows every field and formatting option. It isn't in the list above, so it's
//    never displayed, not even on the development server. Copy it into the list to start an article.
export const articleTemplate: NewsPost = {
  slug: "example-article-template",
  title: "Example article (template)",
  summary: "A draft that shows every formatting option. Copy it to start a new article.",
  publishedOn: "2026-10-14",
  author: "Kole Medical",
  category: "Template",
  status: "draft",
  seoTitle: "Example article",
  seoDescription: "Template article for the Kole Medical news page.",
  relatedWebinars: [],
  body: [
    "A plain string like this one is a paragraph. Keep paragraphs short: two to four sentences read best on a phone.",
    { heading: "Headings split longer articles" },
    "Links are written like this: [the SAHPRA website](https://www.sahpra.org.za/) or, for pages on this site, [our services](/service).",
    { list: ["A bulleted list item", "Another item, which can also contain [a link](/events)"] },
    { list: ["First step", "Second step"], ordered: true },
    { quote: "Quotes are for something a named person said.", cite: "Name, role" },
  ],
};
